import * as React from 'react';
import { InjectedRouter, PlainRoute } from 'react-router';
import { Location } from 'lib/ReactRouterTypes';
import AdminOrganizationSettingsContainer from './AdminOrgApprovalSettingsContainer';
import AdminOrganizationSettingsView from './AdminOrgApprovalSettingsView';
import { OrganizationType } from 'globalTypes';
import { withRouter } from 'app/context/Router';

type Props = {
  organizationUUID: string;
  orgId: string;
  groupCode: string;
  orgType: OrganizationType;
  route: PlainRoute;
  router: InjectedRouter;
  location: Location;
};

function AdminOrganizationSettings(props: Props) {
  const { orgId, organizationUUID, route, groupCode, orgType, router, location } = props;

  return (
    <AdminOrganizationSettingsContainer organizationUUID={organizationUUID}>
      {({
        approvalSettings,
        onOrgApprovalSettingsSave,
        districtSettings,
        onDistrictSettingsSave,
        canSendUrgentMessage,
      }) => {
        return (
          <AdminOrganizationSettingsView
            approvalSettings={approvalSettings}
            onOrgApprovalSettingsSave={onOrgApprovalSettingsSave}
            districtSettings={districtSettings}
            onDistrictSettingsSave={onDistrictSettingsSave}
            canSendUrgentMessage={canSendUrgentMessage}
            orgUuid={organizationUUID}
            orgId={Number(orgId)}
            groupCode={groupCode}
            orgType={orgType}
            route={route}
            router={router}
            location={location}
          />
        );
      }}
    </AdminOrganizationSettingsContainer>
  );
}

export { AdminOrganizationSettings };
export default withRouter(AdminOrganizationSettings);
